// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"49a15903","977":"452f6133"}[chunkId] + ".chunk.js";
};